module.exports = __webpack_public_path__ + "img/video.ce815598.png";